import { Component, Renderer2, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  constructor(private router: Router,
    private renderer: Renderer2) {
    router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChange());
  }

  inPublicPortal = true;
  ngOnInit() {
    this.handleRouteChange()
  }
  handleRouteChange = () => {

   
  };

}
